module.exports = __webpack_public_path__ + "img/notice-modal-zh-CN.6f284868.png";